export default "__VITE_ASSET__BiOioqKR__"